module.exports = {"id":"178415","name":"Ruud Vormer","rating":"78","photo":"./data/images/photos/2/178415.png","club":{"name":"Club Bruges","logo":"./data/images/clubs/ClubBruges.png"},"positions":["MC","MD"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RuudVormer0.json
// module id = 3751
// module chunks = 0